var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('HeaderClient',{attrs:{"client":_vm.getSelectedProduct.name ? _vm.getSelectedProduct.name : 'Sin Información',"showPublic":_vm.getPublicGap.public}}),_c('vs-row',{attrs:{"w":12}},[_c('vs-col',{attrs:{"w":12}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }